import { Injectable } from '@angular/core';
import { UtilService } from './util.service';
import { ClipboardService } from 'ngx-clipboard';
import { Router, NavigationEnd, NavigationError, NavigationCancel } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsoleService {

  private _logOfConsole = [];
  private _api = [];
  private _navigation = [];
  private _log = console.log;
  private _warn = console.warn;
  private _error = console.error;

  constructor(
    private util: UtilService,
    private router: Router,
    private _clipboard: ClipboardService
  ) { }

  init() {
    const self = this;

    if (!(['local', 'development'].includes(environment.environment))) {

      console.log = function() {
        if (arguments[0] == 'API') {
          self.remove1(self._api);
          self._api.push({ arguments });
        } else {
          self.remove1(self._logOfConsole);
          self._logOfConsole.push({ method: 'log', arguments });
        }
        return self._log.apply(console, arguments);
      };

      console.warn = function() {
        if (arguments[0] == 'API') {
          self.remove1(self._api);
          self._api.push({ arguments });
        } else {
          self.remove1(self._logOfConsole);
          self._logOfConsole.push({ method: 'warn', arguments });
        }
        return self._warn.apply(console, arguments);
      };

      console.error = function() {
        if (arguments[0] == 'API') {
          self.remove1(self._api);
          self._api.push({ arguments });
        } else {
          self.remove1(self._logOfConsole);
          self._logOfConsole.push({ method: 'error', arguments });
        }
        return self._error.apply(console, arguments);
      };

    }

    this.init_router();
  }

  init_router() {
    this.router.events.subscribe(event => {
      let type;
      if (event instanceof NavigationError) { type = 'NavigationError'; }
      if (event instanceof NavigationCancel) { type = 'NavigationCancel'; }
      if (event instanceof NavigationEnd) { type = 'NavigationEnd'; }

      if (type) {
        this.remove1(this._navigation);
        this._navigation.push({
          date: new Date(),
          type,
          event
        });
      }
    });
  }

  remove1(item: any[]) {
    if (item.length > 100) {
      item.shift();
    }
  }

  show() {
    this.util.dialog.dialog({
      message: JSON.stringify(this._logOfConsole),
      title: 'Ultimos logs registrados',
      buttons: [
        { text: 'COPIAR', color: 'accent' },
        { text: 'FECHAR', color: 'primary' }
      ]
    }).then((res) => {
      if (res == 'COPIAR') {
        if (this.toClipboard()) {
          this.util.toast.success('Registro enviado para a area de transferência');
        } else {
          this.util.toast.error('Não foi possível copiar o registro');
        }
      }
    });

  }

  toClipboard() {
    const res = {
      console: this._logOfConsole,
      api: this._api,
      router: this._navigation
    };

    return this._clipboard.copyFromContent(JSON.stringify(res));
  }
}
